import axios from "axios";

export default axios.create({
	baseURL: "http://localhost:3800",
	//baseURL: "https://cloudy-api.app.svppb.com",
	headers: {
		"Content-type": "application/json",
	},
});
